<template>
  <v-hover v-slot:default="{ hover }">
    <v-avatar
      v-bind="$attrs"
      v-on="$listeners"
      :color="avatarColor"
      :style="outlined"
      :size="size"
      :class="{ 'text-body-1': true, 'mx-1': true, toFront: hover }"
      v-text="userInitials"
    ></v-avatar>
  </v-hover>
  <!-- Qui avevo anche un class="white--text"
  che aveva senso solo quando il background era tutto colorato-->
</template>

<script>
import colors from 'vuetify/lib/util/colors'

const avatarColors = [
  colors.purple.base,
  colors.indigo.base,
  colors.red.darken1,
  colors.teal.base,
  colors.lightBlue.darken3,
  colors.pink.darken3,
  colors.blueGrey.base,
  colors.cyan.darken3,
  colors.amber.darken4,
  colors.indigo.darken3,
  colors.deepPurple.base,
  colors.teal.darken4,
  colors.blue.darken3,
  colors.deepOrange.darken3,
  colors.lime.darken4,
  colors.indigo.darken4,
  colors.pink.darken4,
  colors.green.darken3,
  colors.purple.darken3,
  colors.deepOrange.base,
  colors.brown.base,
  colors.lightBlue.darken4,
  colors.teal.darken3,
  colors.orange.darken3,
  colors.lightGreen.darken4,
  colors.deepPurple.darken3,
  colors.cyan.darken4,
]

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      required: false,
      default: 44,
    },
  },

  data: () => ({
    // userInitials: '',
    avatarColor: '',
    outlined: '',
  }),

  mounted() {
    // this.userInitials = this.user.firstName.charAt(0) + this.user.lastName.charAt(0)
    this.avatarColor = avatarColors[(this.user.id - 1) % avatarColors.length]
    this.outlined = {
      color: this.avatarColor,
      'border-color': this.avatarColor,
      'border-style': 'solid',
      'border-width': 'thin',
      'background-color': 'var(--v-background-base)',
    }
  },

  computed: {
    userInitials() {
      return this.user.firstName.charAt(0) + this.user.lastName.charAt(0)
    },
  },
}
</script>

<style scoped>
.toFront {
  z-index: 99 !important;
}
</style>
